import Done from './Done/Done'
import Edit from './Edit/Edit'
import Upload from './Upload/Upload'
import Wallet from './Wallet/Wallet'

const Views: { [key: string]: (props: any) => JSX.Element } = { Done, Edit, Upload, Wallet }

export default Views
